import { render, staticRenderFns } from "./contactWay.vue?vue&type=template&id=78730b90&scoped=true"
import script from "./contactWay.vue?vue&type=script&lang=js"
export * from "./contactWay.vue?vue&type=script&lang=js"
import style0 from "./contactWay.vue?vue&type=style&index=0&id=78730b90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78730b90",
  null
  
)

export default component.exports